import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CardComponent } from '../../../../card/card.component';
import { SanitizeHtmlPipe } from '../../../pipes/sanitize-html.pipe';
@Component({
    selector: 'nw-content-card',
    templateUrl: './content-card.component.html',
    styleUrls: ['./content-card.component.scss'],
    standalone: true,
    imports: [CommonModule, SanitizeHtmlPipe, CardComponent, NgOptimizedImage]
})
export class ContentCardComponent {
    @Input() heading?: string;
    @Input() content?: string;
    @Input() theme: string = 'light';
    @Input() icon?: string;
    @Input() clickableurl?: string;

    public get isClickable(): boolean {
        return !!this.clickableurl;
    }
}
